module.exports = __webpack_public_path__ + "img/groupMeet.6e67a712.svg";